module.exports = __webpack_public_path__ + "media/correct-order.4b164795.webm";